import $ from "jquery";
import "magnific-popup";

export default function initImageModals() {
  // Function to initialize Magnific Popup for images
  function initializeMagnificPopup() {
    var imageLinks = $(
      '.body-text a[href$=".jpg"], .body-text a[href$=".jpeg"], .body-text a[href$=".png"], .body-text a[href$=".gif"], .body-text a[href$=".webp"]'
    );

    if (imageLinks.length) {
      imageLinks.magnificPopup({
        type: "image",
        image: {
          titleSrc: function (item) {
            return (
              item.el.find("img").attr("alt") ||
              item.el.find("img").attr("title")
            );
          },
        },
        callbacks: {
          open: function () {
            // Move the close button outside the mfp-figure div
            var $closeBtn = $(".mfp-close");
            var $container = $(".mfp-container");
            if ($closeBtn.length && $container.length) {
              $closeBtn.detach().appendTo($container);
            }
          },
        },
      });
    }
  }

  // Initialize Magnific Popup only if image links are present on DOM ready
  initializeMagnificPopup();
}
